/** Local-only merchant shell so /admin?token= works without Edviron-Backend GraphQL. */

export const PAYOUTS_LOCAL_SHELL_KEY = "payoutsLocalShell";

export const isPayoutsLocalShellEnabled = () =>
  process.env.REACT_APP_PAYOUTS_LOCAL_SHELL === "true" ||
  (process.env.NODE_ENV !== "production" &&
    process.env.REACT_APP_PAYOUTS_DATA_SOURCE === "api");

const getFirstAllowedPayoutSchoolId = () =>
  (
    process.env.REACT_APP_PAYOUTS_SCHOOL_ID ||
    process.env.REACT_APP_PAYOUT_ALLOWED_SCHOOL_IDS ||
    process.env.REACT_APP_PAYOUT_ALLOWED_SCHOOL_ID ||
    process.env.REACT_APP_PAYOUT_SCHOOL_ALLOWLIST ||
    ""
  )
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)[0] || "";

/** Skip Edviron-Backend GraphQL when testing payouts against payouts-service only. */
export const shouldSkipMerchantGraphql = () => {
  if (!isPayoutsLocalShellEnabled()) return false;
  return (
    process.env.REACT_APP_PAYOUTS_LOCAL_SHELL === "true" ||
    localStorage.getItem(PAYOUTS_LOCAL_SHELL_KEY) === "1"
  );
};

export const buildPayoutsLocalShellUser = (merchantToken?: string) => {
  let id = "local_payouts_user";
  try {
    if (merchantToken) {
      const payload = merchantToken.split(".")[1];
      if (payload) {
        const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
        const json = JSON.parse(
          window.atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=")),
        );
        if (json?.id) id = String(json.id);
      }
    }
  } catch {
    // ignore decode errors
  }

  return {
    getMerchantQuery: {
      _id: id,
      name: "Local Payouts Tester",
      email_id: "payouts-local@edviron.test",
      school_id: getFirstAllowedPayoutSchoolId() || "sch_local",
      payouts_enabled: true,
      payout_access: true,
      permissions: ["payouts"],
      enabledFeatures: ["payouts"],
    },
  };
};
